import React, { useCallback, useContext } from 'react';
import ScorecardContext from 'contexts/ScorecardContext';
import Typography from 'kingpin/atoms/Typography';
import { Col } from './styles';
import Row from 'components/Common/Row';
import { Z_INDEX } from '../../../constants';
import { KPI_HEADER_COL_HEIGHT } from './constants';
import useGetFiscalPeriodLabel from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider/useGetFiscalPeriodLabel';
import { getColName } from './getColName';

const ColumnItem = ({
  period,
  noBorder,
}: {
  period: Period;
  noBorder: boolean;
}) => {
  const { scorecard } = useContext(ScorecardContext);
  const getFiscalPeriodLabel = useGetFiscalPeriodLabel();

  return (
    <Col
      minWidth
      alignRight
      style={{
        borderRight: noBorder
          ? undefined
          : `1px solid var(--color-grid-border)`,
        padding: '8px 0',
        height: KPI_HEADER_COL_HEIGHT,
      }}
    >
      <div style={{ paddingRight: '8px', display: 'flex' }}>
        <Typography.Body type="Body 12" color={'var(--color-grey-2)'}>
          {scorecard.cadence === 'fiscalPeriod' && (
            <span>{getFiscalPeriodLabel(period.startDate)}</span>
          )}
          {scorecard.cadence !== 'fiscalPeriod' && (
            <span>{getColName(period, scorecard.cadence)}</span>
          )}
        </Typography.Body>
      </div>
    </Col>
  );
};

const ColumnHeadingsRight = () => {
  const { selectedPeriods, setHoveredKpiId } = useContext(ScorecardContext);

  const onKpiMouseEnter = useCallback(() => {
    setHoveredKpiId(undefined);
  }, [setHoveredKpiId]);

  return (
    <Row
      centerAlign
      onMouseEnter={onKpiMouseEnter}
      style={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'var(--color-bg-primary)',
        zIndex: Z_INDEX.SCORECARD_COLUMN_HEADING,
        borderBottom: `1px solid var(--color-grid-border)`,
        borderTop: `1px solid var(--color-grid-border)`,
        borderRight: `1px solid var(--color-grid-border)`,
      }}
    >
      {selectedPeriods.map((p) => (
        <ColumnItem
          key={p.startDate}
          period={p}
          noBorder={p === selectedPeriods[selectedPeriods.length - 1]}
        />
      ))}
    </Row>
  );
};

export default ColumnHeadingsRight;
